import React, { useEffect, useState } from "react";
import styled from "styled-components";
import StarRatings from "react-star-ratings";

import { Maybe, SanityReview, SanityReviewsBlock } from "@graphql-types";
import { Container, P, StandardLayoutContainer } from "@util/standard";
import { colors } from "@util/constants";
import { Link } from "@global";

interface Props {
  data: Maybe<SanityReviewsBlock>;
}

interface ReviewProps {
  review: SanityReview;
}

const ReviewWrapper = styled(Container)`
  flex-direction: column;

  border-bottom: 1px solid ${colors.lightGrey};
`;

function ReviewsBlock({ data }: Props) {
  if (data?.reviews == null) return null;
  const [numberOfShownReviews, setNumberOfShownReviews] = useState(4);
  const [medianRating, setMedianRating] = useState(0);

  const { reviews, label } = data;

  const calculateMedian = () => {
    let sum = 0;

    reviews.map(item => {
      if (item?.rating == null) return;
      sum = sum + item.rating;
    });

    setMedianRating(sum / reviews.length);
  };

  const loadMore = () => {
    if (numberOfShownReviews >= reviews.length) return;

    setNumberOfShownReviews(numberOfShownReviews + 4);
  };

  useEffect(() => {
    calculateMedian();
  }, []);

  const Review = ({ review }: ReviewProps) => {
    const { name, reviewDate, rating, reviewText } = review;

    return (
      <ReviewWrapper flexDirection="column" width="48%" tabletWidth="100%">
        <Container margin="15px 0 10px 0">
          <P margin="0 15px 0 0">{reviewDate}</P>
          <P margin="0 15px 0 0" fontWeight="bold">
            {name}
          </P>
          {rating && (
            <StarRatings
              rating={rating}
              starRatedColor={colors.gold}
              numberOfStars={5}
              name="recipeRating"
              starDimension="16px"
              starSpacing="2px"
            />
          )}
        </Container>
        <P margin="0 0 15px 0" color="grey">
          {reviewText}
        </P>
      </ReviewWrapper>
    );
  };

  return (
    <StandardLayoutContainer flexDirection="column" margin="auto" tabletWidth="90%">
      <Container width="100%" tabletFlexDirection="column">
        <Container width="52%" tabletWidth="100%">
          <h2>{label ?? "Reviews"}</h2>
        </Container>
        <Container justifyContent="flex-end" flexDirection="column">
          <Container>
            <StarRatings
              rating={medianRating}
              starRatedColor={colors.gold}
              numberOfStars={5}
              name="recipeRating"
              starDimension="16px"
              starSpacing="2px"
            />
            <P margin="0 0 0 15px">{`(${reviews.length} Reviews)`}</P>
          </Container>
        </Container>
      </Container>
      <Container
        justifyContent="space-between"
        flexWrap="wrap"
        tabletFlexDirection="column"
        margin="69px 0 0 0"
        tabletMargin="40px 0 0 0"
      >
        {reviews.map((review, index) => {
          if (review == null || index + 1 > numberOfShownReviews) return null;

          return <Review review={review} />;
        })}
      </Container>
      {numberOfShownReviews < reviews.length && (
        <Container margin="47px 0 0 0">
          <Link linkText="Load More" onClick={loadMore} design="outlineDark" />
        </Container>
      )}
    </StandardLayoutContainer>
  );
}

export default ReviewsBlock;
